import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpParams, HttpClient } from '@angular/common/http';
import 'rxjs/add/operator/map';

import { environment } from '../../environments/environment';
import { RateType } from './rate-type';
import { requestHeaders } from '../shared/api.service';

@Injectable()
export class RateTypeService {
  baseUrl = environment.serverUrl;
  params: HttpParams = new HttpParams();
  public nextUri;
  public count = 0;

  constructor(private http: HttpClient) {
    this.params = new HttpParams();
  }

  list(query: any = null): Observable<RateType[]> {
    if (query) {
      Object.keys(query).forEach((key) => {
        if (typeof query[key] !== 'undefined' && query[key] && query[key].toString) {
          this.params = this.params.set(key, query[key].toString());
        }
      });
    }
    let rateTypesUrl = '/assets/files/rate-types.json';
    return this.http.get(rateTypesUrl, {
      headers: requestHeaders(),
      params: this.params
    }).map(res => {
      return this.extractData(res);
    });
  }

  private extractData(res: Object) {
    let resObj = res;
    this.nextUri = resObj['next'];
    this.count = resObj['count'];
    let body = resObj['results'];
    if (body) {
      return body.map(rateType => {
        return new RateType(rateType);
      });
    } else if (resObj) {
      return new RateType(resObj);
    } else {
      return {};
    }
  }
}
